import JsonApiHelper from '~/helpers/json-api-helper'
import { useAuthStore } from '~/store/auth'
import { useProductsStore } from '~/store/products'
import { useUserStore } from '~/store/user'

export function useCartAndWishList () {
  const authStore = useAuthStore()
  const userStore = useUserStore()
  const productsStore = useProductsStore()
  const { $apiHelper } = useNuxtApp()

  async function updateCartAndWishListTotalItems (): Promise<void> {
    if (!authStore.isGuest && !authStore.isUser) {
      return
    }

    const params = { include: 'cartProducts' }

    try {
      const userOrGuestResponse = authStore.isUser
        ? await $apiHelper.users.getUser(authStore.userId!, params)
        : await $apiHelper.guests.getGuest(params)

      const { data: userOrGuestData } = JsonApiHelper.denormalizeResponse(userOrGuestResponse) as any

      if (authStore.isUser && userOrGuestData) {
        userStore.updateFromUserData(userOrGuestData)
      }

      if (userOrGuestData && userOrGuestData.meta) {
        const { cartTotalItems, wishListTotalItems } = userOrGuestData.meta

        if (Number.isInteger(cartTotalItems) && Number.isInteger(wishListTotalItems)) {
          productsStore.setCartTotalItems(cartTotalItems)
          productsStore.setWishListTotalItems(wishListTotalItems)
        }

        const cartProducts = userOrGuestData.relationships.cartProducts.data

        for (const { id, meta } of cartProducts) {
          productsStore.addCartProduct({ id, quantity: meta.quantity })
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  return { updateCartAndWishListTotalItems }
}
